// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__gF6bF","label":"CategoryService_label__18s4_","location":"CategoryService_location__jLfCB"};